import React, { useContext } from 'react';
import { useNavigate } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { AuthContext } from '../../../App';
import CTAButton from '../../shared/CTAButton';
import Support from '../../shared/Support';

export default function LinkFail() {
  const navigate = useNavigate();
  const auth = useContext(AuthContext);
  const role = auth?.auth?.user?.role;

  return (
    <div id="content" className="max-w-lg mx-auto">
      <div className="flex items-center justify-center">
        <FontAwesomeIcon
          icon={['far', 'triangle-exclamation']}
          className="rounded-full text-2xl p-3 text-negative-red border border-negative-red"
        />
      </div>
      <div className="my-6">
        <p className="text-negative-red font-avenir-black text-3xl text-center my-3">
          Oops!
        </p>

        {role === 'merchant' ? (
          <div className="text-center">
            <div className="my-5">
              <p className="text-lg font-avenir-medium">
                We were unable to link your bank account.
              </p>
              <p className="my-3">
                The Credit Key client success team will reach out to you with
                other options to verify your information.
              </p>
              <p>
                You can contact
                <a
                  href="mailto: support@creditkey.com"
                  className="text-primary-blue underline cursor-pointer mx-1"
                >
                  support@creditkey.com
                </a>
                for updates or questions.
              </p>
            </div>
          </div>
        ) : (
          <div className="text-center">
            <div className="my-5">
              <p className="text-lg font-avenir-medium">
                We were unable to link your bank account.
              </p>
              <p className="my-3">
                However, we can still process your line increase request by
                manually reviewing bank statements.
              </p>
              <a
                href="https://borrower.creditkey.com/?request_credit_increase=true"
                target="_blank"
                rel="noreferrer"
                className="py-2 shadow-md transition duration-150 ease-in-out font-avenir-medium rounded-full text-sm md:text-base inline-block px-32 bg-primary-blue text-white hover:bg-navy-blue"
              >
                Upload bank statements
              </a>
            </div>
          </div>
        )}
        <CTAButton
          buttonText="Try a New Bank Connection"
          icon={['far', 'arrow-left']}
          buttonClass="px-28 text-sm bg-light-gray text-white hover:bg-dark-gray"
          containerClass="my-6 justify-center"
          onClick={() => navigate('/')}
        />
        <div className="mt-10 text-center text-dark-gray">
          <Support fullText={true} />
        </div>
      </div>
    </div>
  );
}
